import React, { Component } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/NavBar";
import img from "../imgs/landscape.jpg";
import bridge from '../imgs/bridge.jpeg';
import LightBox from 'react-images';

const jumbotron = {
  backgroundImage: "url(" + img + ")",
  backgroundPosition: "center",
  backgroundRrepeat: "no-repeat",
  backgroundSize: "cover",
  color: "white",
  height: "100vh"
};



export default class Contact extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="jumbotron jumbotron-fluid" style={jumbotron}>
        
          <div className="container h-70">
          
          <div className="row align-items-center h-100 " style={{background:'white', width:'80%',margin:'auto', marginTop:'5vh'}}>
                <div className="col-lg-6">
                    <div style={{}}>
                     <h3 className="text-center" style={{color:'black'}}>Contact</h3>
                    <p className="text-center" style={{color:'black'}}> <em>I&apos;d Love to hear from You!</em></p>
                    
                    <p className="text-center" style={{color:'black'}}>Fan? Drop a note.</p>
                    <p className="text-center" style={{color:'black'}}> <span className="glyphicon glyphicon-envelope"></span>
                      <a href="mailto:RainPetrosian@gmail.com"> Email: RainPetrosian@gmail.com</a>
                    </p>
                    
                  </div>
                </div>
                <div className="col-lg-6">
                

                     <img className='img-fuid'  src={bridge} style={{width:'80%', minWidth:'20vh', margin:'8%'}}></img>
                </div>
            
            
          </div>
        </div>
        
      </div>
      </div>
    );
  }
}
